export enum CorpOrganizationStatus {
  ACTIVE = 'ACTIVE',
  FROZEN = 'FROZEN',
}
